module.exports = __webpack_public_path__ + "static/media/buttonWIRED.3676cb16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/buttonWIRED.jpg
// module id = 79
// module chunks = 0